import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { InputWrapper, InputLabel, InputError } from 'components/atoms/styleds';

import { StyledTextarea } from './styled';
import { MultiLangItem, MultiLangWrapper } from '../Input/styled';
import { MultiLangData } from '../../../common/constants/multi-lang';

const Textarea = ({
  mt,
  value,
  name,
  label,
  onChange,
  error,
  placeholder,
  desktopMt = 0,
  rows = 4,
  wrapperStyle,
  isMultiLang,
  multiLangValues,
  areaHeight,
  ...rest
}) => {
  const [multiLangKey, setMultiLangKey] = useState('it');

  return (
    <InputWrapper
      style={wrapperStyle}
      desktopMb={0}
      desktopMt={desktopMt}
      mt={mt}
    >
      <StyledTextarea
        height={areaHeight}
        rows={rows}
        name={isMultiLang ? `${name}_${multiLangKey}` : name}
        onChange={onChange}
        value={isMultiLang ? multiLangValues[multiLangKey] : value}
        failed={!!error}
        autoresize={false}
        placeholder={placeholder}
        {...rest}
      />
      <InputLabel style={{ zIndex: 0 }} failed={!!error}>
        {label}
      </InputLabel>
      {!!error && <InputError>{error}</InputError>}
      {isMultiLang && (
        <MultiLangWrapper>
          {Object.keys(MultiLangData).map((key) => {
            const item = MultiLangData[key];
            return (
              <MultiLangItem
                key={key}
                as={item.icon}
                isActive={multiLangKey === key}
                onClick={() => setMultiLangKey(key)}
              />
            );
          })}
        </MultiLangWrapper>
      )}
    </InputWrapper>
  );
};

Textarea.propTypes = {
  mt: PropTypes.number,
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  desktopMt: PropTypes.number,
  onChange: PropTypes.func,
  error: PropTypes.shape({}),
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  areaHeight: PropTypes.number,
};

export default Textarea;
